'use strict';

/*jshint esversion: 6 */
function setBookingDates(arrivalDateString, departureDateString) {
  var event = new CustomEvent('flowQueryDatesEvent', {
    detail: {
      arrivalDate: arrivalDateString,
      departureDate: departureDateString
    }
  });
  window.dispatchEvent(event);
}

function setRoomTypeCode(roomCode) {
  var event = new CustomEvent('flowQueryRoomTypeEvent', {
    detail: {
      roomTypeCode: roomCode
    }
  });
  window.dispatchEvent(event);
}

function setRatePlanCode(ratePlan) {
  var event = new CustomEvent('flowQueryPromoCodeEvent', {
    detail: {
      promoCode: ratePlan
    }
  });
  window.dispatchEvent(event);
}

(function ($, Drupal, drupalSettings, cookies) {
  var drupalLang = drupalSettings.path.currentLanguage;

  // Update the booking Widget
  $('.js-book').on('click', function (e) {
    var rate, room, arrival, departure, arrivalPicker, departurePicker, flowConfigStorage, flowConfigStorageJson, langCode, cookieValue, cookieParts, googtransCookie;

    rate = null;
    room = null;
    arrival = null;
    departure = null;
    arrivalPicker = null;
    departurePicker = null;
    googtransCookie = null;

    cookieValue = "; " + document.cookie;
    cookieParts = cookieValue.split("; googtrans=");
    if (cookieParts.length >= 2) {
      googtransCookie = cookieParts.pop().split(";").shift();
    }

    arrivalPicker = $('.js-book-arrival');
    departurePicker = $('.js-book-departure');

    if (arrivalPicker && arrivalPicker.data('arrival')) {
      arrival = arrivalPicker.data('arrival');
    }

    if (departurePicker && departurePicker.data('departure')) {
      departure = departurePicker.data('departure');
    }

    if ($(this).data('rate-plan-code')) {
      rate = $(this).data('rate-plan-code');
    }

    if ($(this).data('room-type-code')) {
      room = $(this).data('room-type-code');
    }

    if (localStorage.getItem("flowQueryConfig") !== null) {

      langCode = 'en';
      if (window.location.pathname.includes('zh-hans/haitang-bay')) {
        langCode = 'zh-hans';
      } else if (googtransCookie !== null) {

        // google translates language codes..
        switch (googtransCookie) {
          case "/en/es":
            langCode = 'es';
            break;
          case "/en/it":
            langCode = 'it';
            break;
          case "/en/fr":
            langCode = 'fr';
            break;
          case "/en/ar":
            langCode = 'ar';
            break;
          case "/en/pt":
            langCode = 'pt';
            break;
          case "/en/zh-CN":
            langCode = 'zh-hans';
            break;
          case "/en/nl":
            langCode = 'nl';
            break;
          case "/en/ko":
            langCode = 'ko';
            break;
          case "/en/ja":
            langCode = 'ja';
            break;
          default:
            langCode = 'en';
        }
      } else if (drupalLang === 'zh-hans') {
        langCode = 'zh';
      }

      flowConfigStorage = localStorage.getItem("flowQueryConfig");
      flowConfigStorageJson = JSON.parse(flowConfigStorage);
      flowConfigStorageJson.language = langCode;
      localStorage.setItem('flowQueryConfig', JSON.stringify(flowConfigStorageJson));
    }

    setRoomTypeCode(room);
    setRatePlanCode(rate);
    setBookingDates(arrival, departure);

    $('div.check-rates').fadeToggle('fast').css('display', 'flex');
    $('button.DayPickerNavigation_button').trigger('focus');

    e.stopPropagation();
  });

  // move booking widget outside of header on mobile to fix iOS tray jumping
  if ($(window).width() < 1110) {
    $('.col-check-rates').appendTo('.layout-container');
  }

  // close check rates widget - mobile
  if ($(window).width() < 1110) {
    $('.check-rates__close').click(function () {
      closeBookingWidget();
    });
  }

  //close check rates widget function
  var closeBookingWidget = function closeBookingWidget() {
    $('div.check-rates').css('display', 'none');
    $('body').removeClass('scroll-lock');
  };

  // set event listener for check rates widget close button on window resize
  var resizeTimer;

  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(window).width() < 1110) {

        // close booking widget
        $('.check-rates__close').click(function () {
          closeBookingWidget();
        });

        // moving check rates outside of header on mobile
        $('.col-check-rates').appendTo('.layout-container');
      } else {

        // moving check rates outside of header on mobile
        $('.col-check-rates').appendTo('.header--position');
      }
    }, 250);
  });

  $('a.close[type="button"]').focus(function () {
    if ($(this)[0] == $(':focus')[0]) {
      $(this).on('keypress', function (e) {
        if (e.which == 32 || e.which == 13) {
          $(this).parent().parent().parent().parent().removeClass('show').hide();
          $('body').removeClass('scroll-lock modal-open');
          $('.modal-backdrop').removeClass('show').css('display', 'none');
          $(this).parent().parent().parent().parent().prev().find('a.btn')[0].focus();
        }
      });
    }
  });

  var subscribeButton = $('.btn--subscribe-email');
  var popupCloseButton = $('.popup__close');
  var popupOverlay = $('.popup__overlay');
  var bottomLeftCloseBtn = $('.popup__overlay.position--left .popup__close');
  var bottomLeftPopupClosed = false;
  var expiryCookieExists = cookies.get('Drupal.visitor.verb_popup_1');

  function openPopup() {
    $('.popup.popup-slide').attr('aria-hidden', 'false').css('display', 'block');
    $('.block-verb-popup').css('display', 'block');
  }

  function closePopup() {
    $('.block-verb-popup').css('display', 'none');
    $('.popup.popup-slide').removeClass('is-open');
  }

  function closePopupOverlayClick(inClickedElement) {
    if (inClickedElement === popupOverlay[0]) {
      $('.block-verb-popup').css('display', 'none');
      $('.popup.popup-slide').removeClass('is-open');
    }
  }

  function changePopupToCenter() {
    $('.popup__overlay.position--left').removeClass('position--left').addClass('position--center');
    $('.popup.popup-slide').attr('data-position', 'center');
  }

  if (expiryCookieExists) {
    bottomLeftPopupClosed = true;
    changePopupToCenter();
  }

  bottomLeftCloseBtn.click(function (event) {
    bottomLeftPopupClosed = true;
    changePopupToCenter();
  });

  subscribeButton.click(function (event) {
    if (bottomLeftPopupClosed === false) {
      return;
    }
    openPopup();
  });

  popupCloseButton.click(function (event) {
    closePopup();
  });

  popupOverlay.click(function (event) {
    var clickedElement = event.target;
    closePopupOverlayClick(clickedElement);
  });
})(jQuery, Drupal, drupalSettings, window.Cookies);

// pass any data that's on the check rates button directly to the flow
document.addEventListener('click', function () {
  var checkRatesButton, buttonData, rpc, rtc;
  checkRatesButton = document.querySelector('.btn--check-rates.js-book');

  if (checkRatesButton) {
    buttonData = checkRatesButton.dataset;

    if (buttonData.ratePlanCode) {
      rpc = buttonData.ratePlanCode;
      setRatePlanCode(rpc);
    }

    if (buttonData.roomTypeCode) {
      rtc = buttonData.roomTypeCode;
      setRoomTypeCode(rtc);
    }
  }
});